import { TextStyle, type TextStyleOptions } from '@tiptap/extension-text-style'

import {
  COLOR_CLASSNAMES_FOR_TEXT,
  LIGHT_HEX_CODE_TO_COLOR,
} from '@/constants/color'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fontSize: {
      /**
       * Set the font size
       */
      setFontSize: (size: string) => ReturnType
      /**
       * Unset the font size
       */
      unsetFontSize: () => ReturnType
    }
  }
}

export const TextStyleExtended = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      fontSize: {
        default: null,
        parseHTML: (element) => element.style.fontSize.replace('px', ''),
        renderHTML: (attributes) => {
          if (!attributes['fontSize']) {
            return {}
          }
          return {
            style: `font-size: ${attributes['fontSize']}px`,
          }
        },
      },
      color: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-color'),
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {}
          }
          const colorHex = attributes.color
          const resolvedColor = LIGHT_HEX_CODE_TO_COLOR[colorHex]
          return {
            'data-color': colorHex,
            class: COLOR_CLASSNAMES_FOR_TEXT[resolvedColor],
          }
        },
      },
    }
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setFontSize:
        (fontSize) =>
        ({ commands }) => {
          return commands.setMark(this.name, { fontSize: fontSize })
        },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain()
            .setMark(this.name, { fontSize: null })
            .removeEmptyTextStyle()
            .run()
        },
    }
  },
})

export { TextStyleOptions }
